import AddressSearch from "./address-search";


export function navigateToIpLocation(nominatimUrl, map, maxZoom) {
    fetch('https://v4.as13030.net/get_client_ip_location.php')
        .then(r => r.text())
        .then(location => {
            const addressSearch = new AddressSearch(nominatimUrl, map, maxZoom, false)
            addressSearch.performSearchAndPan(location)
        })
}